export function GridFilterDirective ( KEYCODES : any ) : ng.IDirective {
  const directive : ng.IDirective = {
    require : 'ngModel',
    restrict: 'A',
    link (
      scope  : ng.IScope,
      element: any,
      attrs  : ng.IAttributes
    ) {
      const maxLength = 50;

      attrs.$set('maxlength', maxLength);

      const clearFilter = ( e : JQuery.TriggeredEvent ) => {
        element.val('');
        element.trigger('input');
      };

      function handleKeydown ( e : JQuery.TriggeredEvent ) {
        if ( e.keyCode === KEYCODES.esc ) {
          clearFilter(e);

          e.stopPropagation();
        }
      }

      element.on('keydown', handleKeydown);

      element.siblings()
      .find('a')
      .on('click', clearFilter);

      scope.$on('$destroy', () => {
        element.off('keydown', handleKeydown);

        element.siblings()
        .find('a')
        .off('click', clearFilter);
      });
    }
  };

  return directive;
}